import { getFromApiFunction } from "../apiFunctions";

const getComposantes = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/composantes/";
  return getFromApiFunction(endPoint, params);
};

export { getComposantes as getInterventions };
